import config from 'config';
import { initClientApi } from 'retail-front-services/api';
import { baseUrl } from 'retail-front-services/api/extensions';

import { card2cardApiDeclaration } from '@api/card2cardApi';
import { initializeAppApiDeclaration } from '@api/initializeAppApi';

const getApplicationId = (): string => config.get('client.appId');

export const card2cardApi = initClientApi(card2cardApiDeclaration, {
    getApplicationId,
    getConfigExtenders: (extenders) => extenders.add(baseUrl(config.get('client.endpoints.card2card.baseUrl')))
});

export const initializeAppApi = initClientApi(initializeAppApiDeclaration, {
    getApplicationId,
    getConfigExtenders: (extenders) => extenders.add(baseUrl(config.get('client.endpoints.initializeAppApi.baseUrl')))
});
